"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _helpers = require("../../helpers");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const MultiEnum = ({
  value,
  name,
  format,
  schema,
  onChange
}) => {
  // if (typeof value !== 'number') return <span className={'component-string-placeholder' + (fetching ? ' fetching' : '')} style={{width: `${getRandomInt(8,10)}em`}}></span>;

  // if(value === 0) return <span>{schema.options[value]}</span>;

  return /*#__PURE__*/_react.default.createElement("div", null, Object.entries(schema.options).map(([num, string]) => {
    num = parseInt(num);
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "custom-control custom-checkbox",
      key: string
    }, /*#__PURE__*/_react.default.createElement("input", {
      type: "checkbox",
      className: 'custom-control-input',
      id: name + string,
      name: name,
      checked: value & num,
      onChange: event => event.target.checked ? onChange(parseInt(value + num)) : onChange(parseInt(value - num))
    }), /*#__PURE__*/_react.default.createElement("label", {
      className: "custom-control-label",
      htmlFor: name + string
    }, string));
  }));
};
var _default = exports.default = MultiEnum;
module.exports = exports.default;